import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import { common } from '@mui/material/colors';
import BaseTextField from 'common/components/base-text-field';
import { colors } from 'common/constants';
import React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
interface Props {
    name: string;
    options: boolean[];
    rowsTitle: string[];
    columnsTitle: string[];
}
const QuestionMatrixTextbox: React.FC<Props> = ({
    name,
    rowsTitle = [],
    columnsTitle = [],
}) => {
    return (
        <Box>
            <Table
                sx={{
                    backgroundColor: common.white,
                    display: ['none', 'table'],
                }}
            >
                <TableHead>
                    <TableRow>
                        <TableCell
                            sx={{
                                border: `2px solid ${colors.main}`,
                            }}
                        />
                        {columnsTitle.map((option, index) => (
                            <TableCell
                                key={`table-head-${index}`}
                                align="center"
                                sx={{
                                    border: `2px solid ${colors.main}`,
                                    fontSize: [
                                        '1rem',
                                        '1rem',
                                        '1rem',
                                        '2rem',
                                        '2rem',
                                    ],
                                    fontWeight: 500,
                                    lineHeight: '34px',
                                }}
                            >
                                {option}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rowsTitle.map((question, rowIndex) => (
                        <TableRow
                            key={`table-row-${rowIndex}`}
                            sx={{
                                border: `2px solid ${colors.main}`,
                            }}
                        >
                            <TableCell
                                sx={{
                                    border: `2px solid ${colors.main}`,
                                    backgroundColor: common.white,
                                    fontSize: [
                                        '1rem',
                                        '1rem',
                                        '1rem',
                                        '2rem',
                                        '2rem',
                                    ],
                                    fontWeight: 500,
                                }}
                            >
                                {question}
                            </TableCell>
                            {columnsTitle.map((_, colIndex) => (
                                <TableCell
                                    key={`table-cell-${rowIndex}-${colIndex}`}
                                    align="center"
                                    sx={{
                                        border: `2px solid ${colors.main}`,
                                    }}
                                >
                                    <BaseTextField
                                        name={`${name}[${rowIndex}][${colIndex}]`}
                                        fullWidth
                                        InputProps={{
                                            inputProps: {
                                                maxLength: 255,
                                            },
                                        }}
                                        sx={{
                                            '& .MuiInputBase-root': {
                                                fontSize: [
                                                    '1rem',
                                                    '1rem',
                                                    '1rem',
                                                    '2rem',
                                                    '2rem',
                                                ],
                                                '& fieldset': {
                                                    border: 'none',
                                                },

                                                '&:hover fieldset': {
                                                    border: 'none',
                                                },
                                                '&.Mui-focused fieldset': {
                                                    border: `1px solid ${colors.main}`,
                                                },
                                            },
                                        }}
                                    />
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <Box
                sx={{
                    display: ['block', 'none'],
                }}
            >
                {rowsTitle.map((question, rowIndex) => (
                    <>
                        <Accordion
                            key={`accordion-${rowIndex}`}
                            disableGutters
                            sx={{
                                backgroundColor: 'unset',
                                boxShadow: 'none',
                                border: 'none',
                                padding: 0,
                                fontSize: '1.2rem',
                                color: common.white,
                                fontWeight: 700,
                                borderBottom: `2px solid ${common.white}`,
                                '&::before': {
                                    display: 'none',
                                },
                            }}
                        >
                            <AccordionSummary
                                expandIcon={
                                    <ExpandMoreIcon
                                        sx={{
                                            fontSize: '3rem',
                                            color: common.white,
                                            transform: 'rotate(-90deg)',
                                            transition: 'transform 0.3s ease',
                                            '.Mui-expanded &': {
                                                transform: 'rotate(-180deg)',
                                            },
                                        }}
                                    />
                                }
                                aria-controls="panel1-content"
                                id="panel1-header"
                                sx={{
                                    padding: 0,
                                    marginBottom: '0.5rem',
                                    marginTop: '0.5rem',
                                }}
                            >
                                {question}
                            </AccordionSummary>
                            <AccordionDetails
                                sx={{
                                    color: common.white,
                                    padding: 0,
                                }}
                            >
                                {columnsTitle.map((item, colIndex) => {
                                    return (
                                        <>
                                            <Typography
                                                sx={{
                                                    marginBottom: 1,
                                                }}
                                            >
                                                {item}
                                            </Typography>
                                            <BaseTextField
                                                key={`text-field-${rowIndex}-${colIndex}`}
                                                name={`${name}[${rowIndex}][${colIndex}]`}
                                                fullWidth
                                                placeholder="Vui lòng chọn"
                                                multiline
                                                rows={5}
                                                InputProps={{
                                                    inputProps: {
                                                        maxLength: 255,
                                                    },
                                                }}
                                                sx={{
                                                    marginBottom: 3,
                                                    '& .MuiInputBase-root': {
                                                        backgroundColor:
                                                            common.white,
                                                        borderRadius: '10px',
                                                    },
                                                }}
                                            />
                                        </>
                                    );
                                })}
                            </AccordionDetails>
                        </Accordion>
                    </>
                ))}
            </Box>
        </Box>
    );
};

export default QuestionMatrixTextbox;
